import React from 'react'
import { Navbar, Nav, Container, Button, Dropdown, Row, } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react';
import '../css/Header.css'
import '../css/horizontalmenu.css'
import auth from "../auth";
import PropTypes from "prop-types";
import { withRouter, Link,NavLink,useLocation } from 'react-router-dom';
import NotificationPopper from '../components/Poppers/NotificationPopper';
import UserAccountsPopper from '../containers/UserAccountPopperContainer'
import IdleTimer from 'react-idle-timer'

const userChannel = new BroadcastChannel('user');

class CustomHeader extends React.Component {

    static propTypes = {
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { history } = this.props;
        this.state = {
            goFull: false
        }
        this.idleTimer = null

        this.goFullScreen = this.goFullScreen.bind(this)
        this.logoutButton = this.logoutButton.bind(this)

        this.handleOnAction = this.handleOnAction.bind(this)
        this.handleOnActive = this.handleOnActive.bind(this)
        this.handleOnIdle = this.handleOnIdle.bind(this)
        this.logoutButton = this.logoutButton.bind(this)
        this.feedbackButton = this.feedbackButton.bind(this)
    }


    isActiveFunc = (location, targetURLs) => {
        return targetURLs.includes(location.pathname);
      };
    goFullScreen(e) {

        if (this.state.goFull == false) {
            document.documentElement.requestFullscreen();
            this.setState(
                { goFull: true }
            )
        }
        else {
            document.exitFullscreen();
            this.setState(
                { goFull: false }
            )
        }
    }

    logoutButton() {
        debugger
        this.props.resetAppHandler('test')
        localStorage.clear();
        console.log('i have reset app and clear storage');
        
        // this.setState({reportStartDate:null})
        // this.setState({reportEndDate:null})
        // this.props.history.push("/Login");
        // console.log('i am unable to move to login page');


        auth.logout(() => {
            localStorage.setItem('tabClosed', 'false');
            // window.location.reload();
            
            this.props.history.push("/Login");


        })

    }

    feedbackButton() {
        this.props.history.push("/FeedbackContainer");

    }

    helpButton() {

        // window.open('imageassets/customerGuide.pdf', '_blank');
        
        window.open('imageassets/Shell Telematics Guide Pack.pdf', '_blank');

    }



    handleOnAction(event) {

    }

    handleOnActive(event) {

    }

    handleOnIdle(event) {
        console.log('User is idle!');
        //this.props.history.push("/Login");
        // history.push("/Login");


        this.logoutButton()
    }


    render() {
        const ManageTargetURLs = ['/Manage', '/ManageShellCard','/ManageVehicleGroups','/UpdateUserProfile'];
        const SupiciousTargetURLs = ['/ManageSusTransSub', '/ManageSuspiciousTransaction','/ViewSuspTransSummary'];
        const ReportsTargetURLs = ['/EventAndReports', '/GeneralReports','/TrackerReport'];
        const AdministrationTargetURLs = ['/Administration', '/UpdatePassword','/ActivityLog'];
        const AccountSelectionTargetURLs = ['/AccountSelection']
        if (localStorage.getItem('userid') == null || localStorage.getItem('userid') == '') {
            this.props.resetAppHandler('Logging Out')
            auth.logout(() => {
                this.props.history.push("/Login");
            })
        }

        return (
            <div className="container" >
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                     timeout={1000 * 60 * 10}
                     //timeout={1000 * 30}
                    onActive={this.handleOnActive}
                    onIdle={this.handleOnIdle}
                    onAction={this.handleOnAction}
                    debounce={250}
                />
                <div className="col-xl-12 col-sm-12 col-md-12 d-none d-lg-block">

                    <Navbar className="headerShadow" fixed="top" expand="lg" style={{ width: 400 }}>
                        <Container>
                            <Navbar.Brand>
                                <Link to='./AccountSelection'><img src="imageassets/shell_logo.png" className="logo logoShadow mr-4 mt-2 mb-2" /></Link>
                                <div className="mt-2">
                                    <UserAccountsPopper UserBranches={this.props.data}></UserAccountsPopper>
                                </div>
                            </Navbar.Brand>

                            <Navbar.Toggle aria-controls='responsive-navbar-nav' >
                            </Navbar.Toggle>
                            <Navbar.Collapse id="responsive-navbar-nav" className="rightMenu">
                                <Nav.Item>
                                    <li className="nav-item d-none d-lg-block">
                                        <a className="nav-link nav-link-expand" onClick={this.goFullScreen}>
                                            <FeatherIcon className="full-screen iconspacing" icon="maximize" size="20" />
                                        </a>
                                    </li>
                                </Nav.Item>
                                <Nav.Item>
                                    <NotificationPopper></NotificationPopper>
                                </Nav.Item>
                                <Nav.Item>
                                    <Button 
                                        onClick={this.helpButton}
                                        variant="dark" 
                                        className="rectangle myBtn">
                                        <FeatherIcon className="iconspacing" icon="help-circle" size="15" />
                                        Help
                                    </Button>{' '}
                                </Nav.Item>

                                <Nav.Item>
                                    <Button 
                                        onClick={this.feedbackButton}
                                        variant="warning myBtn" >
                                        <FeatherIcon className="iconspacing" icon="thumbs-up" size="15" />
                                        Feedback
                                    </Button>{' '}
                                </Nav.Item>
                                <Nav.Item>
                                    <Button
                                        onClick={this.logoutButton}
                                        variant="danger" className="rectangle myBtn">
                                        <FeatherIcon className="iconspacing" icon="log-out" size="15" />
                                        Logout
                                    </Button>{' '}
                                </Nav.Item>
                            </Navbar.Collapse>
                            <img src="imageassets/flag.png" className="flag" />
                        </Container>
                    </Navbar>

                    <div className="dummyDiv"> &nbsp; </div>

                    {/* <Navbar className="headerfixed headerShadow" expand="lg">
                        <Container>
                            <Navbar.Toggle aria-controls='responsive-navbar-nav' >
                            </Navbar.Toggle>

                            <Navbar.Collapse id="responsive-navbar-nav">

                                <Nav.Item className="navbar-nav navitemspacing">
                                <NavLink
                exact
                to="/"
                className="text-decoration-none CustomNavStyling"
                activeClassName="activeNav" // Set the class name for the active NavLink
              >
                Home
              </NavLink> */}
                                    {/* <Link className="text-decoration-none CustomNavStyling" to="/">
                                        <FeatherIcon className="iconspacing-Nav" icon="home" size="15" />
                                        Home
                                    </Link> */}
                                {/* </Nav.Item>
                                <Nav.Item className="navbar-nav navitemspacing">

                                    <Link className="text-decoration-none CustomNavStyling" to="/Manage">
                                        <FeatherIcon className="iconspacing-Nav" icon="package" size="15" />
                                        Manage
                                    </Link>
                                </Nav.Item>
                                <Nav.Item className="navbar-nav navitemspacing">

                                    <Link className="text-decoration-none CustomNavStyling" to="/ManageSusTransSub">
                                        <FeatherIcon className="iconspacing-Nav" icon="package" size="15" />
                                        Suspicious Transactions
                                    </Link>
                                </Nav.Item>
                               
                                <Nav.Item className="navbar-nav navitemspacing">

                                    <Link className="text-decoration-none CustomNavStyling" to="/EventAndReports">
                                        <FeatherIcon className="iconspacing-Nav" icon="calendar" size="15" />
                                         Reports</Link>
                                </Nav.Item>
                                <Nav.Item className="navbar-nav navitemspacing">

                                    <Link className="text-decoration-none CustomNavStyling" to="/Administration">
                                        <FeatherIcon className="iconspacing-Nav" icon="layers" size="15" />
                                        Administration</Link>
                                </Nav.Item>
                                {/* <Nav.Item className="navbar-nav navitemspacing">

                                    <Link className="text-decoration-none CustomNavStyling" to="/Finance">
                                        <FeatherIcon className="iconspacing-Nav" icon="pie-chart" size="15" />
                                        Finance</Link>
                                </Nav.Item> */}
                            {/* </Navbar.Collapse>
                        </Container>
                    </Navbar> */} 
<Navbar className="headerfixed headerShadow" expand="lg">
      <Container>
        <Navbar.Toggle aria-controls='responsive-navbar-nav' />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="navbar-nav">
            <Nav.Item className="navitemspacing">
              <NavLink
                exact
                to="/"
                className="text-decoration-none CustomNavStyling"
               
                activeClassName="activeNav" // Set the class name for the active NavLink
              >
                <FeatherIcon className="iconspacing-Nav" icon="home" size="15" />
                Home
              </NavLink>
            </Nav.Item>
            <Nav.Item className="navitemspacing">
              <NavLink
                to="/Manage"
                className="text-decoration-none CustomNavStyling"
                isActive={(match, location) => this.isActiveFunc(location, ManageTargetURLs)}
                activeClassName="activeNav"
              >
                <FeatherIcon className="iconspacing-Nav" icon="package" size="15" />
                Manage
              </NavLink>
            </Nav.Item>
            <Nav.Item className="navitemspacing">
              <NavLink
                to="/ManageSusTransSub"
                className="text-decoration-none CustomNavStyling"
                isActive={(match, location) => this.isActiveFunc(location, SupiciousTargetURLs)}
                activeClassName="activeNav"
              >
                <FeatherIcon className="iconspacing-Nav" icon="package" size="15" />
                Suspicious Transactions
              </NavLink>
            </Nav.Item>
            <Nav.Item className="navitemspacing">
              <NavLink
                to="/EventAndReports"
                className="text-decoration-none CustomNavStyling"
                isActive={(match, location) => this.isActiveFunc(location, ReportsTargetURLs)}
                activeClassName="activeNav"
              >
                <FeatherIcon className="iconspacing-Nav" icon="calendar" size="15" />
                Reports
              </NavLink>
            </Nav.Item>
            <Nav.Item className="navitemspacing">
              <NavLink
                to="/Administration"
                className="text-decoration-none CustomNavStyling"
                isActive={(match, location) => this.isActiveFunc(location, AdministrationTargetURLs)}
                activeClassName="activeNav"
              >
                <FeatherIcon className="iconspacing-Nav" icon="layers" size="15" />
                Administration
              </NavLink>
            </Nav.Item>
            <Nav.Item className="navitemspacing">
              <NavLink
                to="/AccountSelection"
                className="text-decoration-none CustomNavStyling"
                isActive={(match, location) => this.isActiveFunc(location, AccountSelectionTargetURLs)}
                activeClassName="activeNav"
              >
                <FeatherIcon className="iconspacing-Nav" icon="user" size="15" />
                Switch Account
              </NavLink>
            </Nav.Item>
            {/* Add other NavItems with NavLink as above */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>

                </div>

                <div className="d-xl-none" id="navbar-mobile">
                    <Navbar fixed="top" expand="lg">
                        <Container>
                            <Navbar.Toggle aria-controls='responsive-navbar-nav' >
                            </Navbar.Toggle>
                            <Navbar.Brand>
                                <Button
                                    onClick={this.logoutButton}
                                    variant="danger" className="rectangle myBtn">
                                    Logout
                                </Button>{' '}
                                <img src="imageassets/flag.png" className="flag" />
                            </Navbar.Brand>
                            <Navbar.Collapse id="responsive-navbar-nav">
                                <Nav.Item className="navbar-nav navitemspacing">
                                    <img src="imageassets/shell_logo.png" className="logoMobileView" />
                                </Nav.Item>
                                <Nav.Item className="navbar-nav navitemspacing">
                                    <div className="row">
                                        <FeatherIcon className="iconspacing-Nav-Mobile" icon="home" size="15" />
                                        <Link to="/">Home</Link>
                                    </div>
                                </Nav.Item>
                                <Nav.Item className="navbar-nav navitemspacing">
                                    <div className="row">
                                        <FeatherIcon className="iconspacing-Nav-Mobile" icon="package" size="15" />
                                        <Link to="/Manage">Manage</Link>
                                    </div>
                                </Nav.Item>
                                <Nav.Item className="navbar-nav navitemspacing">
                                    <div className="row">
                                        <FeatherIcon className="iconspacing-Nav-Mobile" icon="layers" size="15" />
                                        <Link to="/ManageSusTransSub">Suspicious Transactions</Link>
                                    </div>
                                </Nav.Item>
                                <Nav.Item className="navbar-nav navitemspacing">
                                    <div className="row">
                                        <FeatherIcon className="iconspacing-Nav-Mobile" icon="calendar" size="15" />
                                        <Link to="/EventAndReports">Reports</Link>
                                    </div>
                                </Nav.Item>
                                <Nav.Item className="navbar-nav navitemspacing">
                                    <div className="row">
                                        <FeatherIcon className="iconspacing-Nav-Mobile" icon="pie-chart" size="15" />
                                        <Link to="/Administration">Administration</Link>
                                    </div>
                                </Nav.Item>
                                <Nav.Item className="navbar-nav navitemspacing">
                                    <div className="row">
                                        <FeatherIcon className="iconspacing-Nav-Mobile" icon="help-circle" size="15" />
                                        <Link to="/AccountSelection"> Switch Account</Link>
                                    </div>
                                </Nav.Item> 
                                {/* <Nav.Item className="navbar-nav navitemspacing">
                                    <div className="row">
                                        <FeatherIcon className="iconspacing-Nav-Mobile" icon="thumbs-up" size="15" />
                                        <Link to="/FeedbackContainer">Feedback</Link>
                                    </div>
                                </Nav.Item> */}
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>
                </div>
            </div>
        );
    }
}

export default withRouter(CustomHeader);

